interface Props {
  mt: string;
  message: string;
}

const EnterDataMessage: (props: Props) => JSX.Element = (props: Props) => {
  return (
    <div className={`col-lg-12 ${props.mt}`}>
      <div className="d-flex align-items-center justify-content-center">
        <div className="card w-100">
          <div className="py-8 text-center mx-auto mw-20">
            <img src={require('src/assets/images/placeholder-illustration.svg').default} alt="" />
            
            <p className="mt-8 color-monoNormal">
              { props.message }
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnterDataMessage;
